import React from 'react';
import styled from 'styled-components';
export const MarkerIcon = ({ children }) => React.createElement(StyledIconWrapper, null, children);
export const Marker = ({ text, textColor, backgroundColor, icon }) => (React.createElement(StyledMarker, { "$backgroundColor": backgroundColor, "$textColor": textColor },
    icon && React.createElement(StyledIconWrapper, null, icon),
    text));
const StyledIconWrapper = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.4rem;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;
const StyledMarker = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  line-height: 1;
  white-space: nowrap;
  padding: 0.8rem;
  font-size: ${({ theme }) => theme.fontSizes.caption.default};
  background: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors.grey.light};
  color: ${({ $textColor, theme }) => $textColor || theme.colors.dark};

  ${StyledIconWrapper} svg {
    fill: ${({ $textColor, theme }) => $textColor || theme.colors.grey.dark};
  }
`;
